import appInfo from "@common/appInfo";
import useStorage from "@common/hooks/storage";
import classNames from "classnames";
import React from "react";
import { useAiChatValue, type UseAiChatValueArgs } from "./hooks";
import Modal from "./Modal";
import Toggle from "./Toggle";
import { type AiChatApi } from "./types";

import "./style.less";

type PersisedState = {
  isVisible: boolean;
  currentChatId: string | null;
};

type Props = {
  api: AiChatApi;
  isHidden?: boolean;
  modalClassName?: string;
  modalTitle: string;
};
const AiChat = (props: Props) => {
  const [modalState, patchModalState] = useStorage<PersisedState>({
    defaultValue: {
      isVisible: false,
      currentChatId: null
    },
    key: `SHARED_AI_CHAT_MODAL_${appInfo.user?.id ?? "anonymous"}`
  });
  const args = React.useMemo(
    (): UseAiChatValueArgs => ({
      api: props.api,
      currentChatId: modalState.currentChatId
    }),
    [props.api]
  );
  const chat = useAiChatValue(args);

  const onOpen = React.useCallback(() => patchModalState({ isVisible: true }), [patchModalState]);
  const onClose = React.useCallback(() => patchModalState({ isVisible: false }), [patchModalState]);

  return (
    <>
      <Toggle onClick={onOpen} hidden={modalState.isVisible || !!props.isHidden} />
      <Modal
        agentName={chat.agentName}
        className={classNames(props.modalClassName, {
          "admin _theme_": appInfo.user?.isStaff || appInfo.user?.isSuperUser
        })}
        data={chat.data}
        isChatDisabled={!chat.isAvailable}
        isLoading={chat.isLoading}
        isVisible={modalState.isVisible && !props.isHidden}
        onClose={onClose}
        sendMessage={chat.sendMessage}
        title={props.modalTitle}
        welcomeMessage={chat.welcomeMessage}
      />
    </>
  );
};
export default AiChat;
